import React from 'react'
import {css} from '@emotion/core'
import {createMarkup} from '../../graphql/datoCmsDataFactory'

const instructionalModalTranslations = require('../../translations/instructionalModal.json')

const InstructionalModal = ({setShowInstructionalModal, lang = `en`}) => {
    const handleClose = (e) => {
        e.stopPropagation()
        e.preventDefault()
        setShowInstructionalModal(false)
    }

    const localizations = instructionalModalTranslations[lang] ?? instructionalModalTranslations.en
    const {heading, steps} = localizations

    return (
        <div
            css={css`
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: black;
                z-index: 9999;
                display: flex;
                flex-direction: column;
                gap: 10px;
                justify-content: center;
                align-items: center;
            `}
            onClick={(e) => handleClose(e)}
            role="button"
            tabIndex="0"
            onKeyDown={(e) => handleClose(e)}
        >
            <div>
                <h2
                    css={css`
                        color: white;
                        font-size: 40px;
                    `}
                >
                    {heading}
                </h2>
                <ol
                    css={css`
                        li {
                            color: white;
                            font-size: 40px;
                            b {
                                color: white;
                            }
                        }
                    `}
                >
                    {steps.map((stepHtml, index) => (
                        // eslint-disable-next-line react/no-danger
                        <li key={index} dangerouslySetInnerHTML={createMarkup(stepHtml)} />
                    ))}
                </ol>
            </div>
        </div>
    )
}

export default InstructionalModal
